import React from "react";
import { Box, Divider, Typography } from "@bca/ui-library";
import styled from "styled-components";

import PricingAndVATProps from "./PricingAndVAT.type";
import media from "../media";
import { formatPrice } from "./PricingAndVAT";
import HPISpecCheck from "./HPISpecCheck";

const PricingBox = styled(Box)`
  display: none;
  ${media.mobile} {
    display: flex;
  }
`;

const PricingAndVATMobile: React.FunctionComponent<PricingAndVATProps> = ({
  saleChannel,
  buyNowPrice,
  capClean,
  vatType,
  currentBid,
  hpi,
  HPISpecCheckLink,
  vehicleAnalytics,
}) => {
  const shouldShowDivider =
    (saleChannel !== "InternetAuction" && Boolean(buyNowPrice)) ||
    (saleChannel === "Tender" && Boolean(currentBid));

  return (
    <PricingBox
      display="flex"
      flexDirection="column"
      paddingX={4}
      paddingY={4}
      width="100%"
    >
      <Box display="flex" width="100%" justifyContent="space-between">
        <Box display="flex" flexDirection="column" alignItems="flex-start">
          {saleChannel === "Tender" && Boolean(currentBid) && (
            <>
              <Typography variant="body-small" color="grey-blue" m={0}>
                Current Bid
              </Typography>
              <Typography variant="body-small" color="grey-blue" m={0}>
                {formatPrice(currentBid)}
              </Typography>
            </>
          )}
        </Box>
        <Box display="flex" flexDirection="column" alignItems="flex-end">
          {saleChannel !== "InternetAuction" && Boolean(buyNowPrice) && (
            <>
              <Typography
                variant="body"
                color="footer-blue"
                fontWeight="semiBold"
                m={0}
              >
                Buy Now
              </Typography>
              <Typography variant="h5" m={0}>
                {buyNowPrice}
              </Typography>
            </>
          )}
        </Box>
      </Box>
      {shouldShowDivider && (
        <Divider
          width="100%"
          my={3}
          css={`
            background-color: #c9ccd2;
            opacity: 50%;
          `}
        />
      )}
      <Box
        display="flex"
        flexDirection="column"
        css={`
          gap: 12px;
        `}
      >
        {Boolean(hpi) && (
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
          >
            <HPISpecCheck
              starRating={hpi.optionsRating}
              price={hpi.optionsPrice}
              anchorLink={HPISpecCheckLink}
              vehicleAnalytics={vehicleAnalytics}
            />
          </Box>
        )}
        <Box display="flex" justifyContent="space-between">
          <Box display="flex" flexDirection="column" alignItems="flex-start">
            <Typography variant="body-small" color="grey-blue" m={0}>
              {Boolean(capClean) ? "CAP Clean" : ""}
            </Typography>
            <Typography variant="body-small" m={0}>
              {capClean}
            </Typography>
          </Box>
          <Typography variant="body-small" color="grey-blue" m={0}>
            {vatType}
          </Typography>
        </Box>
      </Box>
    </PricingBox>
  );
};

export default PricingAndVATMobile;
